export default {
  paddedAMPMHours(hours) {
    const normalizedAMPMHours = Math.min(Math.max(parseInt(hours), 1), 12);
    return normalizedAMPMHours.toString().padStart(2, "0");
  },

  paddedMinutes(minutes) {
    const normalizedMinutes = Math.min(Math.max(parseInt(minutes), 0), 59);
    return normalizedMinutes.toString().padStart(2, "0");
  },

  mounted() {
    this.el.addEventListener("input", (event) => {
      const value = event.target.value.replace(/[^0-9]/g, "").slice(0, 4);

      if (value.length <= 2) {
        event.target.value = value;
      } else if (value.length === 3) {
        const hours = value.slice(0, 2);
        const minutes = value[2];

        event.target.value = this.paddedAMPMHours(hours) + ":" + minutes;
      } else {
        const hours = value.slice(0, 2);
        const minutes = value.slice(2);

        event.target.value =
          this.paddedAMPMHours(hours) + ":" + this.paddedMinutes(minutes);
      }
    });
  },
};
